import { render, staticRenderFns } from "./CrossIcon.vue?vue&type=template&id=5f1ba824"
import script from "./CrossIcon.vue?vue&type=script&lang=ts"
export * from "./CrossIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f1ba824')) {
      api.createRecord('5f1ba824', component.options)
    } else {
      api.reload('5f1ba824', component.options)
    }
    module.hot.accept("./CrossIcon.vue?vue&type=template&id=5f1ba824", function () {
      api.rerender('5f1ba824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/CrossIcon.vue"
export default component.exports